module.exports = __webpack_public_path__ + "img/tum.e0a631eb.jpeg";